export const keyboardArray = [
  "c",
  "c#",
  "d",
  "d#",
  "e",
  "f",
  "f#",
  "g",
  "g#",
  "a",
  "a#",
  "b"
];

export const keyboardFrequencies = [
  32.7032,
  34.6479,
  36.7081,
  38.8909,
  41.2035,
  43.6536,
  46.2493,
  48.9995,
  51.913,
  55,
  58.2705,
  61.7354,
  65.4064,
  69.2957,
  73.4162,
  77.7817,
  82.4069,
  87.3071,
  92.4986,
  97.9989,
  103.826,
  110,
  116.541,
  123.471,
  130.813,
  138.591,
  146.832,
  155.563,
  164.814,
  174.614,
  184.997,
  195.998,
  207.652,
  220,
  233.082,
  246.942,
  261.626,
  277.183,
  293.665,
  311.127,
  329.628,
  349.228,
  369.994,
  391.995,
  415.305,
  440,
  466.164,
  493.883,
  523.251,
  554.365,
  587.33,
  622.254,
  659.255,
  698.456,
  739.989,
  783.991,
  830.609,
  880,
  932.328,
  987.767,
  1046.5,
  1108.73,
  1174.66,
  1244.51,
  1318.51,
  1396.91,
  1479.98,
  1567.98,
  1661.22,
  1760,
  1864.66,
  1975.53,
  2093,
  2217.46,
  2349.32,
  2489.02,
  2637.02,
  2793.83,
  2959.96,
  3135.96,
  3322.44,
  3520,
  3729.31,
  3951.07,
  4186.01
];

export const keyboardMap = {
  "a": { "note": "c", "octave": 0 },
  "w": { "note": "c#", "octave": 0 },
  "s": { "note": "d", "octave": 0 },
  "e": { "note": "d#", "octave": 0 },
  "d": { "note": "e", "octave": 0 },
  "f": { "note": "f", "octave": 0 },
  "t": { "note": "f#", "octave": 0 },
  "g": { "note": "g", "octave": 0 },
  "y": { "note": "g#", "octave": 0 },
  "h": { "note": "a", "octave": 0 },
  "u": { "note": "a#", "octave": 0 },
  "j": { "note": "b", "octave": 0 },
  "k": { "note": "c", "octave": 1 },
  "o": { "note": "c#", "octave": 1 },
  "l": { "note": "d", "octave": 1 },
  "p": { "note": "d#", "octave": 1 },
  ";": { "note": "e", "octave": 1 }
};

export const keymap = {
  "8": "backspace",
  "9": "tab",
  "13": "enter",
  "16": "shift",
  "17": "ctrl",
  "18": "alt",
  "19": "pause/break",
  "20": "caps lock",
  "27": "escape",
  "33": "page up",
  "34": "page down",
  "35": "end",
  "36": "home",
  "37": "left arrow",
  "38": "up arrow",
  "39": "right arrow",
  "40": "down arrow",
  "45": "insert",
  "46": "delete",
  "48": "0",
  "49": "1",
  "50": "2",
  "51": "3",
  "52": "4",
  "53": "5",
  "54": "6",
  "55": "7",
  "56": "8",
  "57": "9",
  "65": "a",
  "66": "b",
  "67": "c",
  "68": "d",
  "69": "e",
  "70": "f",
  "71": "g",
  "72": "h",
  "73": "i",
  "74": "j",
  "75": "k",
  "76": "l",
  "77": "m",
  "78": "n",
  "79": "o",
  "80": "p",
  "81": "q",
  "82": "r",
  "83": "s",
  "84": "t",
  "85": "u",
  "86": "v",
  "87": "w",
  "88": "x",
  "89": "y",
  "90": "z",
  "91": "left window key",
  "92": "right window key",
  "93": "select key",
  "96": "numpad 0",
  "97": "numpad 1",
  "98": "numpad 2",
  "99": "numpad 3",
  "100": "numpad 4",
  "101": "numpad 5",
  "102": "numpad 6",
  "103": "numpad 7",
  "104": "numpad 8",
  "105": "numpad 9",
  "106": "multiply",
  "107": "add",
  "109": "subtract",
  "110": "decimal point",
  "111": "divide",
  "112": "f1",
  "113": "f2",
  "114": "f3",
  "115": "f4",
  "116": "f5",
  "117": "f6",
  "118": "f7",
  "119": "f8",
  "120": "f9",
  "121": "f10",
  "122": "f11",
  "123": "f12",
  "144": "num lock",
  "145": "scroll lock",
  "186": "semi-colon",
  "187": "equal sign",
  "188": "comma",
  "189": "dash",
  "190": "period",
  "191": "forward slash",
  "192": "grave accent",
  "219": "open bracket",
  "220": "back slash",
  "221": "close braket",
  "222": "single quote"
};

export const keyTranspose = {
  note: 1.0594,
  semitone: 0.088,
  cent: 0.00088
};